import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/(site)/login/login-form.js");
;
import(/* webpackMode: "eager" */ "/root/Flare-Backoffice-Nextjs/app/(site)/login/login.css");
